module.exports = __webpack_public_path__ + "img/10000-coin-banner.ed70d552.png";